import { useMutation, useQueryClient } from "@tanstack/react-query";
import { post } from "api/api-methods";
import { useBookingId } from "hooks/use-booking-id";
import { WebBooking } from "types/web-booking";

interface InquiryRespondParameters {
    accept: boolean;
    message: string;
}

export const useInquiryRespond = () => {
    const queryClient = useQueryClient();
    const id = useBookingId();

    const postInquiryRespond = (parameters: InquiryRespondParameters) =>
        post<WebBooking, InquiryRespondParameters>(
            `WebBooking/WebBookings/${id}/InquiryProposalRespond`,
            parameters
        );

    return useMutation({
        mutationFn: postInquiryRespond,
        onSuccess: (data) => {
            queryClient.setQueryData<WebBooking>(["booking", id], () => {
                return new WebBooking(data);
            });
        },
        onError: (error) => {
            console.error("Error responding to inquiry", error);
        },
    });
};
